import { useAppSelector } from "features/store";
import { ReactNode } from "react";
import { Navigate } from "react-router-dom";

type AdminRouteProps = {
  children: ReactNode;
};

const AdminRoute = ({ children }: AdminRouteProps): JSX.Element => {
  const { isAuthenticated, user } = useAppSelector((state) => state.auth);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (user && !user.is_pass_reset) {
    return <Navigate to="/reset-password" replace />;
  }

  const pp = user?.platform_profile;
  const hasIntegrationAccess =
    pp &&
    !pp.is_archived &&
    (pp.is_superuser ||
      pp.is_calibrate_manager ||
      pp.is_integration_dashboard_user ||
      pp.user_type === "internal");

  if (!user || !hasIntegrationAccess) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;
